import { PriceRegion, PriceSegment, ProductPriceCell, ProductPriceOverviewRow, ProductRegionOverview } from '@/app/shared/interfaces/product-price-overview.interface';
import { StockStatus } from '@/app/shared/interfaces/product.interface';

export const SEGMENTS: PriceSegment[] = ['MT', 'MV', 'MC'];
export const REGIONS: PriceRegion[] = ['HN', 'HCM'];

export const SEGMENT_LABELS: Record<PriceSegment, string> = {
  MT: 'MT - khách thường',
  MV: 'MV - role Vip',
  MC: 'MC - role KHCL'
};

export const REGION_LABELS: Record<PriceRegion, string> = { HN: 'Hà Nội', HCM: 'Hồ Chí Minh' };

// Giá hiện theo kiểu Việt Nam (dấu chấm ngăn nghìn); null là chưa có dòng trong bảng giá đó.
export function formatPrice(value: number | null | undefined): string {
  return value === null || value === undefined ? 'N/A' : Math.round(value).toLocaleString('vi-VN');
}

export function formatNumber(value: number | null | undefined): string {
  return value === null || value === undefined ? '—' : value.toLocaleString('vi-VN');
}

// Nhãn trạng thái tồn của Ecom, cùng chữ với màn /product cũ.
export function stockStatusLabel(status: number | null | undefined): string {
  switch (status) {
    case null:
    case undefined: return '—';
    case StockStatus.OnHand: return 'Mở bán';
    case StockStatus.TempporarilyUnavailable: return 'Ẩn bán';
    case StockStatus.NotAllowedToViewPrice: return 'Không hiển thị giá bán';
    case StockStatus.OutOfStock: return 'Hết hàng';
    case StockStatus.NotAllowedToOrder: return 'Không cho phép mua';
    case StockStatus.NotInBusinessScope: return 'Không thuộc phạm vi KD';
    default: return 'Khác';
  }
}

export function notSellableLabel(reason: ProductPriceCell['notSellableReason']): string {
  return reason === 'blacklist' ? 'Nằm trong bảng chặn (blacklist)' : reason === 'whitelist' ? 'Không nằm trong bảng cho phép (whitelist)' : '';
}

export function priceCell(row: ProductPriceOverviewRow, segment: PriceSegment, region: PriceRegion): ProductPriceCell | undefined {
  return row.prices.find(p => p.segment === segment && p.region === region);
}

export function regionOf(row: ProductPriceOverviewRow, region: PriceRegion): ProductRegionOverview | undefined {
  return row.regions.find(r => r.region === region);
}

// "còn 7 / 11": hạn mức của mức giá Limit, đã trừ số đã bán.
export function limitedText(cell: ProductPriceCell | undefined): string {
  const limited = cell?.limited;
  if (!limited) return '';
  return limited.remaining > 0 ? `còn ${formatNumber(limited.remaining)} / ${formatNumber(limited.limitTotal)}` : `hết ${formatNumber(limited.limitTotal)}`;
}
